/* unplugin-vue-components disabled */import { render } from "./TyttPrivacyPolicy.vue?vue&type=template&id=17d8bfc0&scoped=true"
import script from "./TyttPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./TyttPrivacyPolicy.vue?vue&type=script&lang=js"

import "./TyttPrivacyPolicy.vue?vue&type=style&index=0&id=17d8bfc0&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d8bfc0"]])

export default __exports__